const website = {
  link: "https://gam3hub.in",
  name: "Gam3Hub",
  instagram: "",
  facebook: "",
  whatsapp: "",
};

export default website;
